import { BusinessProfileForm } from "@/features/clients/components/business-profile-form";
import { IndividualProfileForm } from "@/features/clients/components/individual-profile-form";
import type { ProfileFormProps } from "@/features/clients/components/profile-form-shared";

/**
 * Client profile form. Individual and Business clients have genuinely different
 * data (business has no personal-name or spouse fields), so each type gets its
 * own form component instead of one form branching on `isBusiness` throughout.
 */
export function ClientProfileForm(props: ProfileFormProps) {
  if (props.client.type === "Business") return <BusinessProfileForm {...props} />;
  return <IndividualProfileForm {...props} />;
}
